module.exports = __webpack_public_path__ + "img/草@2x.3c5613d0.png";